<script setup>
import TitleTwo from '@/components/title-des/titleTwo.vue'

const loopData0 = ref([
  {
    lanhuBg0:
      ' center / contain no-repeat url(https://static.idicc.cn/cdn/official/H5/about_item1_bg.png)',
    lanhuimage0: 'https://static.idicc.cn/cdn/official/H5/about_item1.png',
    lanhutext0: '企业文化',
    lanhutext1: '求是&nbsp;精进&nbsp;创新',
  },
  {
    lanhuBg0:
      ' center / contain no-repeat url(https://static.idicc.cn/cdn/official/H5/about_item2_bg.png)',
    lanhuimage0: 'https://static.idicc.cn/cdn/official/H5/about_item2.png',
    lanhutext0: '企业愿景',
    lanhutext1: 'AI驱动产业发展的领导者',
  },
  {
    lanhuBg0:
      ' center / contain no-repeat url(https://static.idicc.cn/cdn/official/H5/about_item3_bg.png)',
    lanhuimage0: 'https://static.idicc.cn/cdn/official/H5/about_item3.png',
    lanhutext0: '企业使命',
    lanhutext1: '让产业发展像呼吸一样自然！',
  },
])
</script>

<template>
  <div class="brainPart w-full">
    <div class="text-[36px] text-[#333] text-left leading-[50px] mt-4 ml-4">
      公司简介
    </div>
    
    <div class="text-[22px] text-[#666] text-left leading-[40px] mt-4 px-4 indent-[2em]">
      艾瑞数云(IDICC)致力于数据驱动产业发)展的探索和实践,拥有 产业经济学、人工智能大模型、产业运营、产业投资等领域专家且成的跨界复合型团队。
    </div>
    <div class="text-[22px] text-[#666] text-left leading-[40px] mt-4 px-4 indent-[2em]">
      公司以"产业智库引领、数智平台支撑、招商网络助力、产发生态赋能"为核心理念,构建"哒达智库、哒达数智、哒达产发"三大业务矩阵,打造"研·判·召·管·服·培"县域经济全栈赋能生态体系,助力区县经济高质量发展。
    </div>
    <img src="https://static.idicc.cn/cdn/official/H5/about_imgs.png" alt="" class="img1">
    <div
      class="w-full flex justify-center gap-2"
    >
      <div
        v-for="item in loopData0"
        :key="item.title"
        :style="{ background: item.lanhuBg0 }"
        class="w-[220px] h-[230px] relative"
      >
        <div class="culture-icon-wrapper">
          <img class="culture-icon" referrerpolicy="no-referrer" :src="item.lanhuimage0">
        </div>
        <div class="culture-text-group">
          <span class="culture-title" v-html="item.lanhutext0" />
          <span class="culture-subtitle" v-html="item.lanhutext1" />
        </div>
      </div>
    </div>
    <div class="honer w-full flex flex-col relative items-center">
      <TitleTwo title="我们的荣誉" top="16px" bottom="2px" sub-title="" />
      <img src="https://static.idicc.cn/cdn/official/H5/about_honer1.png" alt="" class="img2">
      <div class="flex justify-center w-full absolute z-10 left-0 bottom-[-187px] gap-6">
        <div class="img3" />
        <div class="img4" />
      </div>
    </div>
    <img src="https://static.idicc.cn/cdn/official/H5/about_honer4.png" alt="" class="img5">
  </div>
</template>

<style lang="less" scoped>
.brainPart {
  .selected {
    color: #1741cd;
  }

  .brainCards {
    margin-right: 24px;
    padding: 24px;
    box-sizing: border-box;
    border: 2px solid #829cc1;

    .brainCardsDes {
      color: #999999;
      margin-top: 12px;
      padding: 8px 8px 0px 8px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }
}
.scrollBar {
  ::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
}
.img1 {
  width: calc(100vw - 64px);
  margin: 20px 32px;
}

.culture-icon-wrapper {
  width: 62px;
  height: 62px;
  background: linear-gradient(180deg, #6BF3FF 0%, #1741CD 100%);
  border-radius: 12px;
  margin-top: 24px;
  margin-left: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.culture-icon {
  width: 32px;
  height: 32px;
}

.culture-text-group {
  margin-top: 20px;
  margin-left: 20px;
  display: flex;
  flex-direction: column;
}

.culture-title {
  font-size: 28px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
}

.culture-subtitle {
  font-size: 24px;
  color: #666;
  line-height: 30px;
}
.honer {
    width: 100%;
    height: 823px;
    background: center / contain no-repeat
      url("https://static.idicc.cn/cdn/official/H5/about_honer_bg.png");
    background-size: 100% 100%;
      margin-top: 64px;

}
.img2 {
  width: calc(100vw - 64px);
  margin: 20px 32px;
}
.img3 {
  width: 240px;
  height: 320px;
  box-shadow: 0px 10px 20px 0px rgba(0,0,0,0.1);
  border-radius: 16px;
  border: 1px solid #E1E1E1;
  background: center / contain no-repeat
  url("https://static.idicc.cn/cdn/official/H5/about_honer2.png");
  background-size: 100% 100%;
}
.img4 {
  width: 240px;
  height: 320px;
  box-shadow: 0px 10px 20px 0px rgba(0,0,0,0.1);
  border-radius: 16px;
  border: 1px solid #E1E1E1;
  background: center / contain no-repeat
  url("https://static.idicc.cn/cdn/official/H5/about_honer3.png");
  background-size: 100% 100%;
}
.img5 {
  width: calc(100vw - 176px);
  margin: 217px 88px 0px 88px;
}
</style>
